export default __webpack_public_path__ + "static/media/hami_video_04.51b032db.jpg";